import { makeStyles, shorthands } from "@fluentui/react-components";
import * as React from "react";
import { AppNavSection } from "../../components/AppNav/AppNavSection.web";
import { ArticleListSection } from "../../components/Articles/ArticleListSection.web";
import { BannerImage } from "../../components/BannerImage/BannerImage.web";
import { PromptArtSection } from "../../components/PromptArt/PromptArtSection.web";
import { SignInHeader } from "../../components/SignInHeader/SignInHeader.web";
import { useFlightContext } from "../../hooks/useFlightContext";
import { PropertyContext } from "../PropertyContext.web";
import type { HomePageProps } from "./HomeContainer.web.data";
import { PromptGridSection } from "./PromptGridSection.web";
import { VideoCarouselSection } from "./VideoCarouselSection.web";

export const useStyles = makeStyles({
  root: {
    fontFamily: "Segoe UI Variable",
    display: "flex",
    flexDirection: "column",
    rowGap: "48px",
    paddingBottom: "120px",
    "@media (max-width: 540px)": {
      fontFamily: "Segoe UI",
      ...shorthands.gap("20px"),
      paddingBottom: "16px",
    },
  },
  sectionGap: {
    display: "flex",
    flexDirection: "column",
    rowGap: "120px",
    "@media (max-width: 953px)": {
      rowGap: "20px",
    },
  },
});

export const HomePage: React.FC<HomePageProps> = ({
  locale,
  serviceHost,
  bannerImageSection,
  videoSection,
  appNavSection,
  promptArtSection,
  privacySection,
  moreSection,
}) => {
  const styles = useStyles();
  const { isFlightActive } = useFlightContext();
  const [setting] = React.useContext(PropertyContext);
  return (
    <>
      {isFlightActive("isSignInSuggestionEnabled") && !setting.user && (
        <SignInHeader />
      )}
      <div className={styles.root} data-testid="home-page">
        <BannerImage {...bannerImageSection} />
        <div className={styles.sectionGap}>
          <VideoCarouselSection {...videoSection} locale={locale} />
          <AppNavSection {...appNavSection} />
          <PromptGridSection locale={locale} serviceHost={serviceHost} />
          <PromptArtSection {...promptArtSection} />
          <ArticleListSection {...privacySection} id="privacy" />
          <ArticleListSection {...moreSection} id="more" />
        </div>
      </div>
    </>
  );
};
